// Downloads a workbook the API builds and streams (format=excel), so the browser
// only saves the file instead of building it from the rows on screen.
//
// Returns nothing; throws an Error whose message comes from the API when it fails.
export async function downloadServerExcel(axios, request, fallbackName) {
  let response;
  try {
    response = await axios.request({ ...request, responseType: "blob", timeout: 0 });
  } catch (error) {
    let message = "Error generating the Excel file";
    // With responseType "blob", error bodies arrive as a Blob too.
    if (error.response && error.response.data instanceof Blob) {
      try {
        const body = JSON.parse(await error.response.data.text());
        message = body.message || message;
      } catch (e) { /* not JSON */ }
    }
    throw new Error(message);
  }

  const disposition = response.headers["content-disposition"] || "";
  const matched = disposition.match(/filename="?([^";]+)"?/i);
  const fileName = matched && matched[1] ? matched[1] : fallbackName;

  const url = window.URL.createObjectURL(new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  }));
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
